import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Form,
  Input,
  Button,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";

import { useToast } from "../../Components/Common/ToastContext";
import { updateSettingsKey, viewSettingsMore } from "./_requests";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const EditSettingsMore = () => {
  document.title = "Paal Dappa | Admin panel";

  const { id } = useParams();
  const { showToast } = useToast();
  const history = useNavigate();
  const [SettingsMore, setSettingsMore] = useState<any>({});

  useEffect(() => {
    viewSettingsMore(id).then((res: any) => {
      setSettingsMore(res);
    });
  }, [id]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      slot_morning_time: SettingsMore.slot_morning_time || "",
      slot_evening_time: SettingsMore.slot_evening_time || "",
      expiry_reminder: SettingsMore.expiry_reminder || "",
      update_type: 2
    },
    validationSchema: Yup.object({
      expiry_reminder: Yup.number()
        .typeError("Please enter a valid number")
        .integer("Please enter an integer")
        .min(0, "Expiry reminder must be greater than or equal to 0"),
    }),
    onSubmit: async (values) => {
      try {
        const res: any = await updateSettingsKey(id, values);
        if (res.status === true || res.data?.status === true) {
          toast.success(res.message || "Settings updated successfully", { autoClose: 3000 });
          history("/settings", { state: { activeTab: "2" } });
        } else {
          toast.error(res.message || "Failed to update settings", { autoClose: 3000 });
        }
      } catch (error: any) {
        toast.error(error.message || "An error occurred", { autoClose: 3000 });
      }
    },
  });

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <Container fluid>
        <BreadCrumb title="Create Product" pageTitle="Paal Dappa" />
        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <h4 className="mb-4 ">Edit Settings</h4>
                <hr /> <br />
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                  }}
                >
                  <Row className="mb-3">
                    <Col md={5}>
                      <Label className="fw-bold">Morning Slot Time</Label>
                    </Col>
                    <Col md={7}>


                      <Input
                        type="time"
                        name="slot_morning_time"
                        value={validation.values.slot_morning_time}
                        onChange={validation.handleChange}
                      />

                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={5}>
                      <Label className="fw-bold">Evening Slot Time</Label>
                    </Col>
                    <Col md={7}>
                      <Input
                        type="time"
                        name="slot_evening_time"
                        value={validation.values.slot_evening_time}
                        onChange={validation.handleChange}

                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={5}>
                      <Label className="fw-bold">Expiry Reminder (Days)</Label>
                    </Col>
                    <Col md={7}>
                      <Input
                        type="number"
                        name="expiry_reminder"
                        value={validation.values.expiry_reminder}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        placeholder="e.g. 5"
                        invalid={
                          validation.touched.expiry_reminder && validation.errors.expiry_reminder ? true : false
                        }
                      />
                      {validation.touched.expiry_reminder && validation.errors.expiry_reminder ? (
                        <div className="invalid-feedback d-block">{validation.errors.expiry_reminder as string}</div>
                      ) : null}
                    </Col>
                  </Row>

                  <div className="text-end">
                    <Button type="submit" color="success" className="me-3 w-sm">
                      Submit
                    </Button>

                    <Button type="button" color="secondary" className="w-sm" onClick={() => history("/settings")}>
                      Cancel
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EditSettingsMore;
